import { useEffect, useState } from "react";
import { getProjectStatusApi } from "../api/predefine";

export function useProjectStatus() {
    const [projectStatus, setProjectStatus] = useState();

    useEffect(() => {
        getProjectStatus();
    }, []);

    const getProjectStatus = async () => {
        const response = await getProjectStatusApi();
        if (response?.data) {
            setProjectStatus(response.data);
        } else {
            setProjectStatus("Token Expired");
        }
    };
    return projectStatus;
}
